import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { createHomework } from "../../../api/endpoints/HomeworkEndpoints";
import { Homework } from "../../../models/Homework";

export default function useCreateHomework(exerciseId: number) {
  return useMutation<Homework, AxiosError>({
    mutationKey: ["create-homework", exerciseId],
    mutationFn: () => createHomework(exerciseId),
  });
}
